
import filtersMixin from "@/mixins/filters"

export default {
  mixins: [filtersMixin],

  // validate ({ store }) { return store.getters["user/isAdmin"] },

  validate ({ i18n }) { return i18n.locale === "ru" },

  layoutProps: {
    titleToken: "nav.pressCenter",
  },

  data: () => ({ news: [] }),

  methods: {
    async filter () {
      const [res, err] = await this.$api.news.getNews({
        params: { ...this.params, "paginator[limit]": 9 },
      })
      if (err) {
        console.error(err)
        return
      }
      this.news = res?.list || []
      this.paginator = res?.paginator || {}
    },
  },
}
